import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import TooltipDiv from '../../shared/TooltipDiv';
import ChartContainer from '../../shared/ChartContainer';

const chartData: ChartProp[] = [
    {
        name: 'Store 1',
        val: 200,
    },
    {
        name: 'Store 2',
        val: 300,
    },
    {
        name: 'Store 3',
        val: 100,
    },
    {
        name: 'Store 4',
        val: 278,
    },
    {
        name: 'Store 5',
        val: 489,
    },
    {
        name: 'Store 6',
        val: 339,
    },
    {
        name: 'Store 7',
        val: 249,
    },
    {
        name: 'Store 8',
        val: 169,
    },
    {
        name: 'Store 9',
        val: 400,
    },
    {
        name: 'Store 10',
        val: 300,
    },
    {
        name: 'Store 11',
        val: 200,
    },
    {
        name: 'Store 12',
        val: 278,
    },
    {
        name: 'Store 13',
        val: 189,
    },
    {
        name: 'Store 14',
        val: 239,
    },
    {
        name: 'Store 15',
        val: 349,
    },
    {
        name: 'Store 16',
        val: 449,
    },
];


interface ChartProp {
    name: string;
    val: number;
}

interface BarChartProps {
    data: ChartProp[];
}

const handler = (menu: string) => {
    console.log(menu);
}
  
const EventTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        return (
            <TooltipDiv>{payload[0].value} Events</TooltipDiv>
        );
    }

    return null;
};

function EventsByStoreChart({ data }: BarChartProps) {
    const theme = useTheme();
    const barColors = ['#218FE6', '#DFFAF9', '#1EA4C4', '#C41E91', '#E6D721', '#4B8CBE', '#00579A'];

    return (
        <ResponsiveContainer width="100%" height="100%" >
            <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                barSize={26}
            >
                <CartesianGrid stroke={theme.palette.shadow.dark} strokeDasharray="3 3" vertical={false} />
                <XAxis
                    dataKey="name"
                    stroke={theme.palette.text.primary}
                    tickLine={false}
                    axisLine={false}
                    strokeDasharray="3 3"
                    style={{
                        fontSize: '0.8rem',
                        fontFamily: 'Montserrat',
                        fontWeight: 100
                    }}
                />
                <YAxis
                    stroke={theme.palette.text.primary}
                    tickLine={false}
                    axisLine={false}
                    style={{
                        fontSize: '0.7rem',
                        fontFamily: 'Montserrat',
                        fontWeight: 100
                    }}
                />
                <Tooltip content={<EventTooltip />} cursor={false} />
                <Bar dataKey="val" fill={theme.palette.secondary.main} radius={[8, 8, 0, 0]} >
                    {
                        data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={barColors[index % 7]} />
                        ))
                    }
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}


export default function EventsByStoreCard() {

    return (

        <Grid item={true} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
            <FFPaper sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column', height: 320,
                alignItems: 'stretch',
                position: 'relative',
                justifyContent: 'stretch',
                border: '0 0 0 0 solid',
            }}>
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />


                <Stack direction="row"
                    sx={{
                        justifyContent: 'stretch',
                        height: '100%',
                    }}
                >

                    <Stack direction="column"
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        sx={{
                            height: '100%',
                            padding: '10px 10px 10px 10px',
                            width: '100%',
                        }}
                    >
                        <Box
                            sx={{
                                pl: 3,
                                pr: 3,
                            }}
                        >
                            <Stack direction="row">
                                <Title subtitle="Last update 1 min ago" notooltip={true}>Events By Store</Title>
                            </Stack>
                        </Box>
                        <ChartContainer>
                        <EventsByStoreChart data={chartData} />
                        </ChartContainer>
                    </Stack>
                </Stack>



            </FFPaper>
        </Grid>
    )

}
